import { CMSocialMedia } from "./social-media-share.styles";
import { ReactComponent as FbIcon } from "../../icons/facebook.svg";
import { ReactComponent as SharingIcon } from "../../icons/sharing.svg";
import { ReactComponent as StarIcon } from "../../icons/star.svg";
import { ReactComponent as Twitter } from "../../icons/twitter-x.svg";
import { ReactComponent as TwitterFooter } from "../../icons/twitter-x-2.svg";
import { ReactComponent as Tiktok } from "../../icons/tiktok.svg";
import { ReactComponent as Instagram } from "../../icons/instagram2.svg";
import { ReactComponent as FilledStarIcon } from "../../icons/star-filled.svg";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Star } from "@mui/icons-material";
import { updateFavorite } from "../../Services/auction.service";
import { useAuth } from "../../Contexts/auth.context";

const SocialMediaShare = (props) => {
  const { url: sharedUrl, hideLinks , auctionName, isWatch, auctionID } = props;
  const [filled, setFilled] = useState(isWatch);
  const { auth } = useAuth();

  const onClickStart = async () => {
    const response = await updateFavorite(auth.userId, auctionID);
    if (response[0].success == 1) {
      setFilled(response[0].message == "Added");
    } 
    else{
      console.warn("Error message: ", response.message)
    }
  };

  const URLShare = () => {
    return sharedUrl || window.location.href;
  };

  const handleEmailShare = () => {
    const currentUrl = URLShare();
    const subject = encodeURIComponent("Take a look at this auction!");
    const body = encodeURIComponent(
      `Hello! I would like to share this auction with you: 
      ${auctionName} : ${currentUrl}`
    );
    const mailtoLink = `mailto:?subject=${subject}&body=${body}`;
    window.location.href = mailtoLink;
  };

  return (
    <CMSocialMedia {...props}>
      {filled ? (
        <FilledStarIcon onClick={onClickStart} style={props.hide} />
      ) : (
        <StarIcon onClick={onClickStart} style={props.hide} />
      )}

      <a href={`http://facebook.com/sharer.php?u=${encodeURIComponent(URLShare())}`} target="_blank">
        <FbIcon style={props.style} />
      </a>
      <a href={`http://twitter.com/intent/tweet?text=MPE&url=${encodeURIComponent(URLShare())}`} target="_blank" >
      {props.footer === 1 ? (
        <TwitterFooter style={props.style} />
      ) : (
        <Twitter style={props.style} />
      )}
      </a>
      <a href={"#"} onClick={handleEmailShare}>
        <SharingIcon style={props.style} />
      </a>
      {!hideLinks && (
        <>
          <a style={{ color: "transparent", userSelect: "none", cursor: "default"}}>
            aaaa
          </a>
          <a style={{ color: "transparent", userSelect: "none", cursor: "default"}}>
            aaaa
          </a>
        </>
      )}
    </CMSocialMedia>
  );
};

export default SocialMediaShare;
